import { useRef, useState } from "react";
import { mdiPlayCircle, mdiStar } from "@mdi/js";
import Icon from "@mdi/react";

export default function Depoimento({video, nome, texto}){

	const videoRef = useRef();
	const [playing, setPlaying] = useState(false);

	function handleClick(){
		console.log( 'a');
		if(videoRef.current.paused){
			videoRef.current.play();
			setPlaying(true);
		}else{
			videoRef.current.pause();
			setPlaying(false);
		}
	}

	function handleOnEnded(){
		setPlaying(false);
	}

	return (
		<div className="d-flex justify-content-center align-items-center">
			<div className="position-relative cursor-pointer" onClick={handleClick}>
				{!playing && (
					<div className="position-absolute d-flex flex-column justify-content-evenly p-3" style={{inset: 0, zIndex: 2, cursor: 'pointer'}}>
						<div/>
						<div className="d-flex flex-column align-items-center">
							<Icon path={mdiPlayCircle} size={3} style={{filter: "drop-shadow(rgba(0, 0, 0, 0.9) 0px 5px 10px)"}}/>
							<div className="fs-4 fw-bold text-white text-center" style={{textShadow: "rgba(0, 0, 0, 0.9) 0px 5px 10px"}}>"{texto}"</div>
						</div>
						<div>
							<div className="d-flex flex-column align-items-center fw-bold" style={{textShadow: "rgba(0, 0, 0, 0.9) 0px 5px 10px"}}>
								<div className="text-primary mb-2">
									<Icon path={mdiStar} size={1} style={{filter: "drop-shadow(rgba(0, 0, 0, 0.9) 0px 5px 5px)"}}/>
									<Icon path={mdiStar} size={1} style={{filter: "drop-shadow(rgba(0, 0, 0, 0.9) 0px 5px 5px)"}}/>
									<Icon path={mdiStar} size={1} style={{filter: "drop-shadow(rgba(0, 0, 0, 0.9) 0px 5px 5px)"}}/>
									<Icon path={mdiStar} size={1} style={{filter: "drop-shadow(rgba(0, 0, 0, 0.9) 0px 5px 5px)"}}/>
									<Icon path={mdiStar} size={1} style={{filter: "drop-shadow(rgba(0, 0, 0, 0.9) 0px 5px 5px)"}}/>
								</div>
								{nome}
							</div>
						</div>
					</div>
				)}
				<video
					ref={videoRef}
					src={video}
					onEnded={handleOnEnded}
					playsInline
					controls={false}
					className={`border border-3 rounded-3 ${playing ? "border-primary" : "border-secondary"}`}
					style={{width: "100%", height: "100%", objectFit: "cover", aspectRatio: 9/13, maxHeight: "70vh", cursor: 'pointer', opacity: playing ? 1 : 0.3, boxShadow: playing ? "rgba(191, 148, 86, 0.5) 0px 0px 50px 0px" : ""}}
				/>
			</div>
		</div>
	)
}